import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { RootState } from 'reducers';
import { HomeService, PlanService } from 'services';
import { HomeImage } from "assets/img";
import NewPlanCard from 'screens/affiliate/components/new-plan-card';
import AdsTable from 'screens/affiliate/components/ads-table';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Home extends React.Component<Props> {

	state = {
		plan: null,
		hasPendingPayment: false
	}
	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Inicio',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		const resPlan: any = await HomeService.affiliate.getPlan({ user_id: this.props.user.id });

		const resPayments: any = await PlanService.admin.getHistory({
			user_id: this.props.user.id,
			page: 1,
		});

		const rows = resPayments?.plan_payments?.rows || [];

		if (!rows.length) {
			this.props.dispatch({ type: 'SET_LIMITED', payload: true });
			this.props.history.replace('/affiliate/plan');
			return;
		}

		const hasPending = rows.some(
			(item: any) => item.status === 0 || String(item.status_text).toLowerCase() === 'pendiente'
		);

		this.setState({
			plan: resPlan.plan,
			hasPendingPayment: hasPending
		});
	}
	render() {
		return (
			<div id="affiliate-home">
				<div>
					<header className="welcome-card">
						<div className="welcome-card__content">
							<div className="welcome-card__illustration">
								<img src={HomeImage} alt="Bienvenida" />
							</div>
							<div className="welcome-card__text">
								<h1 className="welcome-card__title">¡Bienvenido!</h1>
								<p className="welcome-card__user-name">{this.props.user?.name}</p>
							</div>
						</div>
					</header>

					<AdsTable />
				</div>

				<NewPlanCard history={this.props.history} hasPendingPayment={this.state.hasPendingPayment} />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Home);